<template>
  <div class="g-modal" v-if="data.action">
    <div class="g-content">
      <div class="header p-3 mb-3">
        <h4 class="m-0">{{ title }}</h4>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <map-component
        class="mb-3 px-3"
        :data="data"
        @close="closeModal"
      />

    </div>
  </div>
</template>
<script>
import MapComponent from "./Map";

export default {
  components: { MapComponent },
  props: {
    title: {},
  },
  data() {
    return {
      data: {},
    };
  },
  methods: {
    createMap(data) {
      this.data = data;
    },

    closeModal() {
      this.$emit("close");
    },

    closeModal() {
      this.data = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.g-modal {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;

  .g-content {
    background-color: #fff;
    border-radius: 4px;
    max-height: 460px;
    height: 100%;
    max-width: 700px;
    width: 100%;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
    }
  }
}
</style>
